var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"logo-font",attrs:{"to":"/"}},[_vm._v("conduit")]),_c('span',{staticClass:"attribution"},[_vm._v(" Vue + Typescript + Vuex + Vue Router author Gyejoong. ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }